// extracted by mini-css-extract-plugin
export var sliderRange = "_m8-2";
export var sliderRoot = "_m8-0";
export var sliderThumb = "_m8-3";
export var sliderTrack = "_m8-1";